<template>
  <div id="users" style="display: flex; align-content: center" class="mt-4">
    <table class="table table-hover shadow-lg">
      <thead class="thead-dark">
      <tr>
        <th scope="col">Id</th>
        <th scope="col">Name</th>
        <th scope="col" style="width: 25vh">
          <button class="btn text-success btn-link" v-on:click="roleCreate"><i class="fas fa-plus"></i></button>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" v-bind:key="item.id">

        <td>
          {{ item.id }}
        </td>
        <td>
          {{ item.name }}
        </td>

        <td id="button-sector-edit-delete">

          <button class="btn text-secondary btn-link" v-bind:value="item.id" v-on:click="roleEdit(item.id)">
            <i class="far fa-edit"></i>
          </button>
          <button class="btn text-danger  btn-link " v-bind:value="item.id"
                  v-on:click="roleDelete(item.id)">
            <i class="fas fa-trash-alt"></i>
          </button>

        </td>

      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import tokenRefresh from "@/utils/tokenRefresh";
import Swal from "sweetalert2";
import axios from "axios";
import statusCheck from "@/utils/statusCheck";

export default {
  name: "Roles",
  data() {
    return {
      items: '',
    }
  },
  mounted() {
    axios.get(process.env.VUE_APP_CRAWLING_URL + '/api/roles')
        .then((response) => {
              var data = [];
              for (let i = 0; i < response.data.length; i++) {
                data[i] = {
                  "name": response.data[i]['name'],
                  "id": response.data[i]['id'],
                }
              }
              this.items = data;
            }
        )
        .catch(function (error) {
              statusCheck(error.response.status);
            }
        )
  },
  methods: {
    roleEdit: function (id) {
      tokenRefresh();
      this.$router.push({name: "role-edit", params: {id: id}});
    },

    roleDelete: function (id) {
      tokenRefresh();
      Swal.fire({
        title: 'Info!',
        text: 'Are you sure',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        allowOutsideClick: true,

      })
          .then((response) => {
                if (response.isConfirmed)
                  axios.delete(process.env.VUE_APP_CRAWLING_URL + "/api/roles/" + id)
                      .then((response) => {
                            if (response.status === 200) {
                              Swal.fire({
                                title: 'Success!',
                                text: 'Role deleted',
                                icon: 'success',
                                confirmButtonText: 'Ok',
                                allowOutsideClick: true,
                              })
                                  .then(() => {
                                        this.$router.go();
                                      }
                                  );
                            }
                          }
                      )
                      .catch((error) => {
                            if (error.response.status === 406) {
                              Swal.fire({
                                    title: 'Error!',
                                    text: 'Role cannot be deleted, this role is assigned to user',
                                    icon: 'error',
                                    confirmButtonText: 'Ok',
                                    allowOutsideClick: true,
                                  }
                              )
                            }
                          }
                      )
              }
          )

    },
    roleCreate: function () {
      tokenRefresh();
      this.$router.push({name: "role-create"});
    }
  }
}
</script>

<style scoped>

</style>